import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.71 12.76c.16-.01.29-.14.29-.3V9.75h-3c-2.42 0-3.75-1.33-3.75-3.75V3H6Q3 3 3 6v12q0 3 3 3h7.21c.23 0 .39-.25.27-.45-.47-.77-.73-1.67-.73-2.63 0-2.75 2.24-5.01 4.96-5.16M11 16.75H7a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 0 1.5m-4-4a.75.75 0 0 1 0-1.5h7a.75.75 0 0 1 0 1.5zM12.75 6V3.75l4.5 4.5H15c-1.58 0-2.25-.67-2.25-2.25m9.78 15.47-1.55-1.55a3.64 3.64 0 0 0 .603-2.003 3.67 3.67 0 0 0-3.666-3.667 3.67 3.67 0 0 0-3.667 3.667 3.67 3.67 0 0 0 3.667 3.667c.74 0 1.426-.224 2.003-.602l1.55 1.549a.75.75 0 0 0 1.06 0 .75.75 0 0 0 0-1.061m-4.613-1.387a2.17 2.17 0 0 1-2.167-2.167 2.17 2.17 0 0 1 2.167-2.167 2.17 2.17 0 0 1 2.166 2.167 2.17 2.17 0 0 1-2.166 2.167"
    }, null, -1)
  ])))
}
export default { render: render }